import { Youtube } from "lucide-react";
import MusicCard from "@/components/MusicCard";
import { IMAGES } from "@/lib/api";

export default function MusicSection({ tracks, settings }) {
  const channel = settings?.youtube_url || "https://www.youtube.com/@RosefieldHarmonic";

  return (
    <section id="music" data-testid="music-section" className="relative py-24 md:py-32 bg-[#efe1cd] overflow-hidden">
      <img src={IMAGES.portal} alt="" className="absolute -right-24 -top-24 w-96 opacity-30 animate-float pointer-events-none" />
      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="font-accent text-sm tracking-widest-2 uppercase text-[#c2a04b] mb-4">Music & Sound</p>
          <h2 className="font-display text-4xl md:text-5xl text-[#3a2630] leading-tight">
            Frequency transmissions for your field
          </h2>
          <p className="text-[#3a2630]/70 mt-5 leading-relaxed">
            Hover any track for a sneak peek, or press play to listen in full. Each offering is
            tuned to activate, restore, and harmonize.
          </p>
        </div>

        {tracks.length === 0 ? (
          <p className="text-center text-[#3a2630]/60 font-accent">New transmissions arriving soon.</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
            {tracks.map((t, i) => (
              <MusicCard key={t.id} track={t} channelUrl={channel} index={i} />
            ))}
          </div>
        )}

        {settings?.soundcloud_url && (
          <div data-testid="soundcloud-embed" className="mt-14 max-w-3xl mx-auto">
            <p className="text-center font-accent text-sm tracking-widest-2 uppercase text-[#c2a04b] mb-4">More on SoundCloud</p>
            <div className="rounded-2xl overflow-hidden border border-[#e3b4b0]/50 shadow-[0_10px_35px_rgba(156,85,96,0.12)] bg-[#fbf6ec]">
              <iframe
                title="Rosefield Harmonic on SoundCloud"
                width="100%"
                height="320"
                scrolling="no"
                frameBorder="no"
                allow="autoplay"
                src={`https://w.soundcloud.com/player/?url=${encodeURIComponent(settings.soundcloud_url)}&color=%23b76e79&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=false`}
              />
            </div>
          </div>
        )}

        <div className="text-center mt-14">
          <a
            href={channel}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="music-channel-cta"
            className="inline-flex items-center gap-2 font-accent tracking-wide px-8 py-3.5 rounded-full bg-[#281620] text-[#f7efe2] hover:bg-[#9c5560] transition-colors"
          >
            <Youtube size={20} /> Explore the full collection
          </a>
        </div>
      </div>
    </section>
  );
}
